import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ComList from '../ComList';

class UpdateSystemExp extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        systemTypeOptions: [],
    }

    queryVitaeList = (typeName) => {
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeList,
            data: {typeName},
            dataType: 'json',
            doneResult: res => {
                const { vitaeList = [] } = res;
                const options = vitaeList.map(item => {
                    const { vitaeDictId, chName, enName, childList } = item;
                    return {
                        zh: chName,
                        en: enName,
                        value: vitaeDictId,
                        child: childList,
                    };
                });
                this.setState({ systemTypeOptions: options });
            }
        };
        $.sendRequest(options);
    }

    show = (record) => {
        const params = {
            ...(record || {}),
        };
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        }, () => {
            this.queryVitaeList('SYSTEM_EXPERIENCE');
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            systemTypeOptions: [],
        });
    }
    
    getRenderList = () => {
        const { isChinese } = this.props;
        const { params, systemTypeOptions } = this.state;
        const { systemTypeId } = params;
        const systemTypeOption = (systemTypeOptions || []).find(i => i.value == systemTypeId) || {};
        const isSystemTypeOther = systemTypeOption.en === 'Other';
        const systemNameOptions = (systemTypeOption.child || []).map(i => ({
            value: i.vitaeDictId,
            zh: i.chName,
            en: i.enName,
        }));

        systemTypeOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        systemNameOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        const renderList = [{
            zh: '系统类型',
            en: 'System Type',
            key: 'systemTypeId',
            require: true,
            option: {
                type: 'select',
                allowClear: false,
                disabled: !isChinese,
                list: systemTypeOptions,
                style: { width: 240 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            },
        }, {
            key: isChinese ? 'systemTypeChinese' : 'systemTypeEnglish',
            require: true,
            colon: false,
            option: {
                type: 'input',
                style: { width: 240 },
                placeholder: isChinese ? '补充其他说明' : 'Please supply other instructions',
            },
            display: {
                symbol: 'eq',
                key: 'systemTypeId',
                toName: true,
                value: isChinese ? '其他' : 'Other',
            },
        }];
        
        if (isSystemTypeOther) {
            renderList.push({
                zh: '系统名称',
                en: 'System Name',
                key: isChinese ? 'systemNameChinese' : 'systemNameEnglish',
                require: true,
                option: {
                    type: 'input',
                    style: { width: 240 },
                    placeholder: isChinese ? '请输入' : 'Please input ',
                    onFocus: () => this.handleFocus('系统类型', 'systemTypeId')
                },
            });
        } else {
            renderList.push({
                zh: '系统名称',
                en: 'System Type',
                key: 'systemNameId',
                require: true,
                option: {
                    type: 'select',
                    allowClear: false,
                    disabled: !isChinese,
                    list: systemNameOptions,
                    style: { width: 240 },
                    placeholder: isChinese ? '请选择' : 'Please select ',
                    onFocus: () => this.handleFocus('系统类型', 'systemTypeId')
                },
            }, {
                key: isChinese ? 'systemNameCommentsChinese' : 'systemNameCommentsEnglish',
                require: true,
                colon: false,
                option: {
                    type: 'input',
                    style: { width: 240 },
                    placeholder: isChinese ? '补充其他说明' : 'Please supply other instructions',
                },
                display: {
                    symbol: 'eq',
                    key: 'systemNameId',
                    toName: true,
                    value: isChinese ? '其他' : 'Other',
                },
            });
        }
        renderList.push({
            zh: '公司名称',
            en: 'Company Name',
            key: isChinese ? 'companyNameChinese' : 'companyNameEnglish',
            option: {
                type: 'input',
                style: { width: 240 },
                placeholder: isChinese ? '请输入' : 'Please input ',
            },
        });
        const setName = (item) => {
            if (isChinese) {
                item.name = item.zh;
            } else {
                item.name = item.en;
            }
        };
        const loopArr = (arr) => {
            if (Array.isArray(arr)) {
                arr.forEach(item => loopArr(item));
            } else {
                setName(arr);
            }
        };
        loopArr(renderList);
        this.renderList = renderList;
    }

    checkValue = param => {
        const { params } = this.state;
        const { name, key, require, option, warning, display } = param;
        const { placeholder } = option;
        
        let noError = true;
        if (require) {
            if (!params[key] && !display) {
                message.warning(`${placeholder}${warning || name || ''}`);
                noError = false;
            } else {
                if (display) {
                    const { symbol, key, value = null } = display;
                    if (symbol === 'eq') {
                        if (value) {
                            const list = this.renderList || [];
                            const tar = list.find(i => i.key === key);
                            const arr = tar.option.list || [];
                            const o = arr.find(a => a.value == params[key]);
                            if (o && o.name === value && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        } else {
                            if (params[key] && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        }
                    }
                }
            }
        }
        return noError;
    }

    submit = () => {
        const {
            params,
        } = this.state;
        const { userId, isChinese } = this.props;
        this.getRenderList();
        const renderList = this.renderList || [];
        const hasError = renderList.every(item => {
            if (Array.isArray(item)) {
                return item.every(i => this.checkValue(i));
            } else {
               return this.checkValue(item);
            }
        });
        if (!hasError) {
            return;
        }

        params.type = isChinese ? 'CHINESE' : 'ENGLISH';
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.saveSystemExperience,
            data: {
                userId,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        if (key === 'systemTypeId') {
            params.systemTypeChinese = '';
            params.systemTypeEnglish = '';
            params.systemNameId = undefined;
            params.systemTypeChinese = '';
            params.systemTypeEnglish = '';
            params.systemNameCommentsChinese = '';
            params.systemNameCommentsEnglish = '';
        } else if (key === 'systemNameId') {
            params.systemNameCommentsChinese = '';
            params.systemNameCommentsEnglish = '';
        } else if (key === 'systemNameChinese' || key === 'systemNameEnglish') {
            params.systemNameId = undefined;
            params.systemNameCommentsChinese = '';
            params.systemNameCommentsEnglish = '';
        }
        this.setState({ params });
    }

    handleFocus = (name, key) => {
        const { params } = this.state;
        if (!params[key]) {
            message.warning(`请先选择${name}`);
        }
    }

    render() {
        const { isEdit, visible, loading, params } = this.state;
        this.getRenderList();
        const list = this.renderList || [];
        return (
            <Modal
                title={`${isEdit ? '修改' : '新增'}使用系统经验`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                confirmLoading={loading}
                maskClosable={false}
                width="480px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ComList
                            list={list}
                            params={params}
                            onChange={(value, key) => this.handleChange(value, key)}
                        />
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateSystemExp;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/UpdateSystemExp.js